exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".craverGiftCardForm-cardForm{display:flex;flex-direction:column}.craverGiftCardForm-fullWidthInput{width:100%;margin:8px 0}\n", ""]);

// exports
